/**
 * Momcozy Nombre de bebé Phase 0 flow controller.
 * The browser implementation is added through test-driven increments below.
 */
(function (root, factory) {
  var api = factory(root);

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.MomcozyBabyNameFlow = api;
    root.MomcozyBabyNameUI = api.UI;
    api.boot(root.document);
  }
})(typeof window !== 'undefined' ? window : null, function (browserRoot) {
  var VERSION = 1;
  var MAX_AGE = 12 * 60 * 60 * 1000;
  var STORAGE_KEY = 'momcozy:baby-names:flow:v1';
  var SUCCESS_STORAGE_KEY = 'momcozy:baby-names:success:v1';
  var VIEWS = ['entry', 'results', 'detail', 'popular', 'success'];
  var OVERLAYS = [null, 'lead_gate', 'lead_form'];
  var RETURN_VIEWS = ['entry', 'results', 'popular'];
  var LOGIN_DIALOG_ID = 'baby-name-login';
  var ROUTE_PARAM = 'baby_name_view';
  var RESULT_TEXT_KEYS = [
    'surname',
    'starting',
    'ending',
    'meanings',
    'theme',
    'origin'
  ];
  var RESULT_ROUTE_KEYS = ['gender'].concat(RESULT_TEXT_KEYS, [
    'syllables',
    'page',
    'sort',
    'popularity'
  ]);
  var BABY_PARAM_KEYS = [ROUTE_PARAM, 'name', 'country'].concat(
    RESULT_ROUTE_KEYS
  );
  var ACTION_EVENTS = [
    'baby-names:focus-generator',
    'baby-names:generate',
    'baby-names:gate-submit',
    'baby-names:gate-skip',
    'baby-names:search',
    'baby-names:view-popular',
    'baby-names:select',
    'baby-names:back',
    'baby-names:refine',
    'baby-names:lead-open',
    'baby-names:lead-submit',
    'baby-names:overlay-close',
    'baby-names:copy',
    'baby-names:login-required',
    'baby-names:results-change',
    'baby-names:popular-change'
  ];
  var COMPONENTS = [
    {
      key: 'hero',
      selector: '[data-baby-name-component="hero"]',
      views: ['entry'],
      label: '组件1 — yg-baby-name-hero.liquid'
    },
    {
      key: 'generation',
      selector: '[data-baby-name-component="generation"]',
      views: ['entry'],
      label: '组件2 — yg-baby-name-generation.liquid'
    },
    {
      key: 'guides',
      selector: '[data-baby-name-component="guides"]',
      sharedSetting: 'showGuides',
      label: '组件3 — yg-baby-name-guides.liquid'
    },
    {
      key: 'tools',
      selector: '.yg-popular-tools',
      sharedSetting: 'showTools',
      label: '组件4 — yg-popular-tools.liquid（复用）'
    },
    {
      key: 'faq',
      selector: '.sec__faq',
      sharedSetting: 'showFaq',
      label: '组件5 — yg-faq.liquid（复用）'
    },
    {
      key: 'list',
      selector: '[data-baby-name-component="list"]',
      views: ['results'],
      label: '组件6 — yg-baby-name-list.liquid'
    },
    {
      key: 'product',
      selector: '[data-baby-name-component="product"]',
      views: ['results', 'detail'],
      label: '组件7 — yg-baby-name-product.liquid'
    },
    {
      key: 'detail',
      selector: '[data-baby-name-component="detail"]',
      views: ['detail'],
      label: '组件8 — yg-baby-name-detail.liquid'
    },
    {
      key: 'top-100',
      selector: '[data-baby-name-component="top-100"]',
      views: ['popular'],
      label: '组件9 — yg-baby-name-top-100.liquid'
    },
    {
      key: 'submit-success',
      selector: '[data-baby-name-component="submit-success"]',
      views: ['success'],
      label: '组件10 — yg-baby-name-submit-success.liquid'
    },
    {
      key: 'dialog-1',
      selector: '[data-baby-name-component="dialog-1"]',
      overlay: 'lead_gate',
      label: '组件11 — yg-baby-name-dialog-1.liquid'
    },
    {
      key: 'dialog-2',
      selector: '[data-baby-name-component="dialog-2"]',
      overlay: 'lead_form',
      label: '组件12 — yg-baby-name-dialog-2.liquid'
    },
    {
      key: 'login-modal',
      selector: '[data-baby-name-component="login-modal"]',
      overlay: 'login',
      label: 'YG Nombre de bebé Login Modal'
    }
  ];
  var activeController = null;
  var VIEW_SCROLL_TARGETS = {
    entry: '[data-baby-name-component="hero"]',
    results: '[data-baby-name-component="list"]',
    detail: '[data-baby-name-component="detail"]',
    popular: '[data-baby-name-component="top-100"]',
    success: '[data-baby-name-component="submit-success"]'
  };
  var GENERATION_SCROLL_TARGET = '[data-baby-name-component="generation"]';
  var SEARCH_SCROLL_TARGET = '[data-baby-name-search-form]';
  var RETURN_ANCHOR_STORAGE_KEY = 'momcozy:baby-names:return-anchor';

  function prefersReducedMotion(root) {
    root = root || browserRoot;
    return Boolean(
      root &&
      typeof root.matchMedia === 'function' &&
      root.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function scrollBehavior(root) {
    return prefersReducedMotion(root) ? 'auto' : 'smooth';
  }

  function scrollToSelector(doc, selector, options) {
    options = options || {};
    if (!doc || !selector) return false;
    var target = doc.querySelector(selector);
    if (!target) return false;
    if (typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({
        behavior: options.behavior || scrollBehavior(browserRoot),
        block: options.block || 'start'
      });
    }
    if (options.focus !== false) {
      var focusable = target.querySelector(
        'button, input, select, textarea, a[href], [tabindex]:not([tabindex="-1"])'
      );
      if (focusable && typeof focusable.focus === 'function') {
        try {
          focusable.focus({ preventScroll: true });
        } catch (error) {
          focusable.focus();
        }
      }
    }
    return true;
  }

  function rememberReturnAnchor(anchor) {
    if (!browserRoot || !browserRoot.sessionStorage || !anchor) return;
    try {
      browserRoot.sessionStorage.setItem(RETURN_ANCHOR_STORAGE_KEY, anchor);
    } catch (error) {
      /* ignore quota / privacy errors */
    }
  }

  function consumeReturnAnchor() {
    if (!browserRoot || !browserRoot.sessionStorage) return null;
    try {
      var anchor = browserRoot.sessionStorage.getItem(
        RETURN_ANCHOR_STORAGE_KEY
      );
      browserRoot.sessionStorage.removeItem(RETURN_ANCHOR_STORAGE_KEY);
      return anchor === 'search' || anchor === 'generation' ? anchor : null;
    } catch (error) {
      return null;
    }
  }

  function isSearchOriginDetail(state) {
    return Boolean(state && state.scrollAnchor === 'search');
  }

  function getViewScrollSelector(view, anchor) {
    if (anchor === 'search') return SEARCH_SCROLL_TARGET;
    if (anchor === 'generation') return GENERATION_SCROLL_TARGET;
    return VIEW_SCROLL_TARGETS[view] || null;
  }

  function createUIHelpers(root) {
    var doc = root && root.document;

    function ensureButtonSpinner(element) {
      if (!doc || !element) return null;
      var spinner = element.querySelector('[data-baby-name-button-spinner]');
      if (spinner) return spinner;
      spinner = doc.createElement('span');
      spinner.className = 'yg-bn-spinner yg-bn-spinner--button';
      spinner.setAttribute('data-baby-name-button-spinner', '');
      spinner.setAttribute('aria-hidden', 'true');
      element.appendChild(spinner);
      return spinner;
    }

    function setButtonLoading(element, loading) {
      if (!element) return;
      if (loading) {
        if (!element.hasAttribute('data-bn-prev-disabled')) {
          element.setAttribute(
            'data-bn-prev-disabled',
            element.disabled || element.getAttribute('aria-disabled') === 'true'
              ? '1'
              : '0'
          );
        }
        if (!element.style.minWidth) {
          var width = element.offsetWidth;
          if (width) element.style.minWidth = width + 'px';
        }
        element.classList.add('is-loading');
        element.setAttribute('aria-busy', 'true');
        element.disabled = true;
        element.setAttribute('aria-disabled', 'true');
        ensureButtonSpinner(element);
        return;
      }

      element.classList.remove('is-loading');
      element.removeAttribute('aria-busy');
      var previousDisabled =
        element.getAttribute('data-bn-prev-disabled') === '1';
      element.removeAttribute('data-bn-prev-disabled');
      element.disabled = previousDisabled;
      if (previousDisabled) element.setAttribute('aria-disabled', 'true');
      else element.removeAttribute('aria-disabled');
      element.style.minWidth = '';
      var spinner = element.querySelector('[data-baby-name-button-spinner]');
      if (spinner) spinner.remove();
    }

    function setDataLoading(container, loading, message) {
      if (!container || !doc) return;
      var overlay = container.querySelector('[data-baby-name-data-loading]');
      if (loading) {
        container.classList.add('is-data-loading');
        container.setAttribute('aria-busy', 'true');
        if (!overlay) {
          overlay = doc.createElement('div');
          overlay.className = 'yg-bn-data-loading';
          overlay.setAttribute('data-baby-name-data-loading', '');
          overlay.setAttribute('role', 'status');
          var spinner = doc.createElement('span');
          spinner.className = 'yg-bn-spinner';
          spinner.setAttribute('aria-hidden', 'true');
          overlay.appendChild(spinner);
          var text = doc.createElement('span');
          text.className = 'yg-bn-data-loading__text';
          text.setAttribute('data-baby-name-data-loading-text', '');
          overlay.appendChild(text);
          var computed = root.getComputedStyle
            ? root.getComputedStyle(container)
            : null;
          if (computed && computed.position === 'static') {
            container.setAttribute('data-bn-position-patched', 'true');
            container.style.position = 'relative';
          }
          container.appendChild(overlay);
        }
        var label = overlay.querySelector('[data-baby-name-data-loading-text]');
        if (label) {
          label.textContent = message || '';
          label.hidden = !message;
        }
        return;
      }

      container.classList.remove('is-data-loading');
      container.removeAttribute('aria-busy');
      if (container.getAttribute('data-bn-position-patched') === 'true') {
        container.style.position = '';
        container.removeAttribute('data-bn-position-patched');
      }
      if (overlay) overlay.remove();
    }

    return {
      setButtonLoading: setButtonLoading,
      setDataLoading: setDataLoading
    };
  }

  var UI = createUIHelpers(browserRoot || { document: null });

  function normalizeText(value, maxLength) {
    var normalized = typeof value === 'string' ? value.trim() : '';
    return maxLength ? normalized.slice(0, maxLength) : normalized;
  }

  function positiveInteger(value, fallback) {
    var parsed = Number(value);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : fallback;
  }

  function defaultPopularCountry(options) {
    var locale = String(
      (options && (options.apiLocale || options.defaultCountry)) || ''
    )
      .trim()
      .toLowerCase();
    if (locale === 'es' || locale.indexOf('es-') === 0) return 'es';
    return 'us';
  }

  function normalizePopularCountry(country, fallback) {
    var code = String(country || '')
      .trim()
      .toLowerCase();
    if (code === 'uk' || code === 'us' || code === 'es') return code;
    return fallback || 'us';
  }

  function normalizeRoute(route, options) {
    route = route || {};
    options = options || {};
    var view = isAllowed(VIEWS, route.view) ? route.view : 'entry';

    if (view === 'results') {
      var results = {
        view: 'results',
        page: positiveInteger(route.page, 1),
        sort: route.sort === 'name' || route.sort === '-name' ? route.sort : '',
        popularity:
          ['50', '100', '-50', '-100'].indexOf(
            String(route.popularity || '')
          ) !== -1
            ? String(route.popularity)
            : ''
      };
      if (route.gender === 'girl' || route.gender === 'boy')
        results.gender = route.gender;
      RESULT_TEXT_KEYS.forEach(function (key) {
        var value = normalizeText(route[key], 100);
        if (value) results[key] = value;
      });
      var syllables = positiveInteger(route.syllables, null);
      if (syllables !== null) results.syllables = syllables;
      return results;
    }

    if (view === 'detail') {
      var name = Array.from(normalizeText(route.name)).slice(0, 80).join('');
      return name ? { view: 'detail', name: name } : { view: 'entry' };
    }

    if (view === 'popular') {
      return {
        view: 'popular',
        country: normalizePopularCountry(
          route.country,
          defaultPopularCountry(options)
        ),
        gender: route.gender === 'boy' ? 'boy' : 'girl'
      };
    }

    if (view === 'success') {
      return hasSuccessGrant(options.successGrant, options.now)
        ? { view: 'success' }
        : { view: 'entry' };
    }

    return { view: 'entry' };
  }

  function parseRoute(search, options) {
    var params = new URLSearchParams(search || '');
    var rawView = normalizeText(params.get(ROUTE_PARAM)) || 'entry';
    var raw = { view: rawView };
    BABY_PARAM_KEYS.forEach(function (key) {
      if (key !== ROUTE_PARAM && params.has(key)) raw[key] = params.get(key);
    });
    return normalizeRoute(raw, options);
  }

  function serializeRoute(route, currentSearch, options) {
    var normalized = normalizeRoute(
      route,
      Object.assign(
        {
          successGrant: createSuccessGrant()
        },
        options || {}
      )
    );
    var params = new URLSearchParams(currentSearch || '');
    BABY_PARAM_KEYS.forEach(function (key) {
      params.delete(key);
    });

    if (normalized.view !== 'entry') params.set(ROUTE_PARAM, normalized.view);
    if (normalized.view === 'results') {
      RESULT_ROUTE_KEYS.forEach(function (key) {
        var value = normalized[key];
        if (key === 'page' && value === 1) return;
        if (value !== '' && value !== null && typeof value !== 'undefined')
          params.set(key, String(value));
      });
    } else if (normalized.view === 'detail') {
      params.set('name', normalized.name);
    } else if (normalized.view === 'popular') {
      params.set('country', normalized.country);
      params.set('gender', normalized.gender);
    }

    var query = params.toString();
    return query ? '?' + query : '';
  }

  function createSuccessGrant(now) {
    return JSON.stringify({
      grantedAt: typeof now === 'number' ? now : Date.now()
    });
  }

  function hasSuccessGrant(raw, now) {
    if (!raw) return false;
    try {
      var parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      var timestamp = typeof now === 'number' ? now : Date.now();
      return Boolean(
        parsed &&
        typeof parsed.grantedAt === 'number' &&
        parsed.grantedAt <= timestamp &&
        timestamp - parsed.grantedAt <= MAX_AGE
      );
    } catch (error) {
      return false;
    }
  }

  function navigate(root, route, options) {
    options = options || {};
    if (!root || !root.location || !root.history)
      return normalizeRoute(route, options);
    var normalized = normalizeRoute(route, options);
    var search = serializeRoute(normalized, root.location.search, options);
    var url =
      (root.location.pathname || '') + search + (root.location.hash || '');
    var state = Object.assign(
      { babyName: true, route: normalized },
      options.state && typeof options.state === 'object' ? options.state : {}
    );
    root.history[options.replace ? 'replaceState' : 'pushState'](
      state,
      '',
      url
    );
    return normalized;
  }

  function hasDetailReturnHistory(state) {
    return Boolean(
      state &&
      state.babyName === true &&
      ['entry', 'results', 'popular'].indexOf(state.sourceView) !== -1
    );
  }

  function validateLeadPayload(payload, options) {
    payload = payload || {};
    options = options || {};
    var invalidFields = [];

    var email = normalizeText(payload.email, 254);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) invalidFields.push('email');

    var dueDate = normalizeText(payload.dueDate, 20).replace(/\s+/g, '');
    // Fecha prevista / cumpleaños del bebé is required on both lead dialogs.
    if (!dueDate) {
      invalidFields.push('dueDate');
    } else {
      // Native <input type="date"> values are always YYYY-MM-DD.
      var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dueDate);
      if (!match) {
        invalidFields.push('dueDate');
      } else {
        var year = Number(match[1]);
        var month = Number(match[2]);
        var day = Number(match[3]);
        var date = new Date(year, month - 1, day);
        if (
          date.getFullYear() !== year ||
          date.getMonth() !== month - 1 ||
          date.getDate() !== day
        ) {
          invalidFields.push('dueDate');
        }
      }
    }

    var optIn = payload.optIn === true;
    // Dialog 2 marketing opt-in is required before submit.
    if (options.requireOptIn && !optIn) invalidFields.push('optIn');

    if (invalidFields.length) {
      return {
        valid: false,
        field: invalidFields[0],
        fields: invalidFields
      };
    }

    return {
      valid: true,
      value: { email: email, dueDate: dueDate, optIn: optIn }
    };
  }

  var KLAVIYO_SUBSCRIBE_EVENT = 'BabyNameGeneratorSubcribeSuccess';

  function resolveKlaviyoEventName(config) {
    var name = config && config.klaviyoEventName;
    if (typeof name === 'string' && name.trim()) return name.trim();
    try {
      var doc = browserRoot && browserRoot.document;
      var node = doc && doc.querySelector('[data-baby-name-flow-config]');
      var parsed = node ? JSON.parse(node.textContent || '{}') : null;
      if (
        parsed &&
        typeof parsed.klaviyoEventName === 'string' &&
        parsed.klaviyoEventName.trim()
      ) {
        return parsed.klaviyoEventName.trim();
      }
    } catch (error) {
      /* use default */
    }
    return KLAVIYO_SUBSCRIBE_EVENT;
  }

  /**
   * Generador de nombres de bebé 订阅成功 Track
   * Identify the profile, then fire BabyNameGeneratorSubcribeSuccess.
   * Fire-and-forget so form UX never waits on Klaviyo.
   *
   * @param {Object} formData
   * @param {string} formData.email
   * @param {string} [formData.dueDate]
   * @param {string} [formData.due_day]
   * @param {string} [formData.firstname]
   * @param {string} [formData.first_name]
   * @param {string} [source]
   */
  function trackBabyNameGeneratorSubscribe(formData, source) {
    formData = formData || {};
    var email = String(formData.email || '').trim();
    if (!email || !browserRoot) return;

    var dueDay = String(formData.due_day || formData.dueDate || '').trim();
    var firstname = String(
      formData.firstname || formData.first_name || ''
    ).trim();

    var identifyPayload = { email: email };
    if (dueDay) identifyPayload.due_day = dueDay;
    if (firstname) identifyPayload.first_name = firstname;

    var trackPayload = {
      due_day: dueDay,
      source: source || 'baby_name_generator_form'
    };
    if (firstname) trackPayload.firstname = firstname;

    function logKlaviyoError(err) {
      if (
        browserRoot.console &&
        typeof browserRoot.console.error === 'function'
      ) {
        browserRoot.console.error('Klaviyo 触发失败', err);
      }
    }

    try {
      if (!browserRoot.klaviyo) browserRoot.klaviyo = [];
      var klaviyo = browserRoot.klaviyo;

      function trackEvent() {
        var eventName = resolveKlaviyoEventName();
        if (typeof klaviyo.track === 'function') {
          return klaviyo.track(eventName, trackPayload);
        }
        if (typeof klaviyo.push === 'function') {
          klaviyo.push(['track', eventName, trackPayload]);
        }
      }

      var identified;
      if (typeof klaviyo.identify === 'function') {
        identified = klaviyo.identify(identifyPayload);
      } else if (typeof klaviyo.push === 'function') {
        klaviyo.push(['identify', identifyPayload]);
      }

      if (identified && typeof identified.then === 'function') {
        identified.then(trackEvent).catch(logKlaviyoError);
        return;
      }
      trackEvent();
    } catch (err) {
      logKlaviyoError(err);
    }
  }

  function createInitialState() {
    return {
      version: VERSION,
      view: 'entry',
      overlay: null,
      returnView: 'entry',
      updatedAt: 0
    };
  }

  function isAllowed(list, value) {
    return list.indexOf(value) !== -1;
  }

  function getLoginCookieName(config) {
    return config &&
      typeof config.cookieName === 'string' &&
      config.cookieName.trim()
      ? config.cookieName.trim()
      : 'momcozy-token';
  }

  function hasLoginCookie(cookieString, cookieName) {
    if (!cookieName) return false;
    return String(cookieString || '')
      .split(';')
      .some(function (cookie) {
        var normalizedCookie = cookie.trim();
        var prefix = cookieName + '=';
        return (
          normalizedCookie.indexOf(prefix) === 0 &&
          normalizedCookie.slice(prefix.length).trim() !== ''
        );
      });
  }

  function isLoggedIn(root, doc) {
    root = root || browserRoot;
    doc = doc || (root && root.document);
    var requestApi = root && root.MomcozyBabyNameRequest;
    if (requestApi && typeof requestApi.hasAuthToken === 'function') {
      return requestApi.hasAuthToken(root, doc);
    }
    return hasLoginCookie(
      doc && doc.cookie,
      getLoginCookieName(root && root.__MC__CONFIG__)
    );
  }

  function transitionState(state, eventName, detail) {
    detail = detail || {};

    if (
      !state ||
      !isAllowed(VIEWS, state.view) ||
      !isAllowed(OVERLAYS, state.overlay)
    ) {
      return state;
    }

    switch (eventName) {
      case 'baby-names:focus-generator':
        return state.view === 'entry' ? state : state;

      case 'baby-names:generate':
        return state.view === 'entry' && state.overlay === null
          ? Object.assign({}, state, { overlay: 'lead_gate' })
          : state;

      case 'baby-names:gate-submit':
      case 'baby-names:gate-skip':
        return state.view === 'entry' && state.overlay === 'lead_gate'
          ? Object.assign({}, state, {
              view: 'results',
              overlay: null,
              returnView: 'results'
            })
          : state;

      case 'baby-names:search':
        return state.view === 'entry' && state.overlay === null
          ? Object.assign({}, state, { view: 'detail', returnView: 'entry' })
          : state;

      case 'baby-names:view-popular':
        return state.view === 'entry' && state.overlay === null
          ? Object.assign({}, state, { view: 'popular', returnView: 'popular' })
          : state;

      case 'baby-names:select':
        if (
          (state.view === 'results' || state.view === 'popular') &&
          state.overlay === null
        ) {
          return Object.assign({}, state, {
            view: 'detail',
            returnView: isAllowed(RETURN_VIEWS, detail.returnView)
              ? detail.returnView
              : state.view
          });
        }
        return state;

      case 'baby-names:back':
        return state.view === 'detail' && state.overlay === null
          ? Object.assign({}, state, {
              view: isAllowed(RETURN_VIEWS, state.returnView)
                ? state.returnView
                : 'entry'
            })
          : state;

      case 'baby-names:refine':
        return state.view === 'popular' && state.overlay === null
          ? Object.assign({}, state, { view: 'entry', returnView: 'entry' })
          : state;

      case 'baby-names:lead-open':
        return (state.view === 'results' || state.view === 'detail') &&
          state.overlay === null
          ? Object.assign({}, state, { overlay: 'lead_form' })
          : state;

      case 'baby-names:lead-submit':
        return state.overlay === 'lead_form'
          ? Object.assign({}, state, {
              view: 'success',
              overlay: null,
              returnView: 'entry'
            })
          : state;

      case 'baby-names:overlay-close':
        return state.overlay !== null
          ? Object.assign({}, state, { overlay: null })
          : state;

      case 'baby-names:copy':
        return state.view === 'success' ? state : state;

      default:
        return state;
    }
  }

  function getDialogAction(dialogId, action) {
    var actions = {
      'baby-name-lead-gate': {
        confirm: 'baby-names:gate-submit',
        cancel: 'baby-names:overlay-close'
      },
      'baby-name-lead-form': {
        confirm: 'baby-names:lead-submit',
        cancel: 'baby-names:overlay-close'
      }
    };
    return actions[dialogId] && actions[dialogId][action]
      ? actions[dialogId][action]
      : null;
  }

  function resetLeadDialog(dialogId, doc) {
    doc = doc || (browserRoot && browserRoot.document);
    if (!doc || !dialogId) return;
    var dialog = doc.querySelector('[data-yg-bn-dialog="' + dialogId + '"]');
    if (!dialog) return;

    dialog.querySelectorAll('[aria-invalid="true"]').forEach(function (field) {
      field.removeAttribute('aria-invalid');
    });
    dialog
      .querySelectorAll('[data-baby-name-field-error]')
      .forEach(function (node) {
        node.hidden = true;
        node.textContent = '';
      });

    var email = dialog.querySelector('input[type="email"]');
    var dueDate = dialog.querySelector('input[type="date"]');
    var optIn = dialog.querySelector('input[type="checkbox"]');

    if (email) email.value = '';
    if (dueDate) {
      dueDate.value = '';
      dueDate.classList.remove('is-filled');
      var wrap = dueDate.closest('[class*="__date-wrap"]');
      if (wrap) wrap.classList.add('is-empty');
    }
    if (optIn) optIn.checked = false;
  }

  function getClosingLeadDialogId(event) {
    var dialog =
      event.target &&
      typeof event.target.closest === 'function' &&
      event.target.closest('[data-yg-bn-dialog]');
    if (!dialog) return null;
    var id = dialog.getAttribute('data-yg-bn-dialog');
    return id === 'baby-name-lead-gate' || id === 'baby-name-lead-form'
      ? id
      : null;
  }

  function serializeState(state, now) {
    var timestamp = typeof now === 'number' ? now : Date.now();
    return JSON.stringify({
      version: VERSION,
      view: state.view,
      overlay: state.overlay,
      returnView: state.returnView,
      updatedAt: timestamp
    });
  }

  function restoreState(raw, now) {
    if (!raw) return null;

    try {
      var parsed = JSON.parse(raw);
      var timestamp = typeof now === 'number' ? now : Date.now();
      var isFresh =
        typeof parsed.updatedAt === 'number' &&
        parsed.updatedAt <= timestamp &&
        timestamp - parsed.updatedAt <= MAX_AGE;

      if (
        parsed.version !== VERSION ||
        !isAllowed(VIEWS, parsed.view) ||
        !isAllowed(OVERLAYS, parsed.overlay) ||
        !isAllowed(RETURN_VIEWS, parsed.returnView) ||
        !isFresh
      ) {
        return null;
      }

      return {
        version: VERSION,
        view: parsed.view,
        overlay: parsed.overlay,
        returnView: parsed.returnView,
        updatedAt: parsed.updatedAt
      };
    } catch (error) {
      return null;
    }
  }

  function readConfig(flowElement) {
    var defaults = {
      enabled: true,
      debugMode: false,
      showComponentLabels: false,
      showGuides: true,
      showTools: true,
      showFaq: true,
      customerFirstName: '',
      klaviyoEventName: KLAVIYO_SUBSCRIBE_EVENT
    };

    if (!flowElement) return defaults;
    var configNode = flowElement.querySelector('[data-baby-name-flow-config]');
    if (!configNode) return defaults;

    try {
      var parsed = JSON.parse(configNode.textContent);
      return Object.assign({}, defaults, parsed);
    } catch (error) {
      return defaults;
    }
  }

  function findWrapper(node) {
    return node && (node.closest('[id^="shopify-section-"]') || node);
  }

  function createBrowserController(doc, flowElement) {
    var config = readConfig(flowElement);
    var state = createInitialState();
    var componentRecords = [];
    var loginMonitorId = null;

    function warn(message) {
      if (config.debugMode && browserRoot && browserRoot.console) {
        browserRoot.console.warn('[BabyNameFlow] ' + message);
      }
    }

    function readStoredState() {
      if (
        !config.enablePersistence ||
        !browserRoot ||
        !browserRoot.sessionStorage
      )
        return null;
      try {
        var rawState = browserRoot.sessionStorage.getItem(STORAGE_KEY);
        var restoredState = restoreState(rawState);
        if (rawState && !restoredState)
          browserRoot.sessionStorage.removeItem(STORAGE_KEY);
        return restoredState;
      } catch (error) {
        return null;
      }
    }

    function writeStoredState() {
      if (
        !config.enablePersistence ||
        !browserRoot ||
        !browserRoot.sessionStorage
      )
        return;
      try {
        var now = Date.now();
        state = Object.assign({}, state, { updatedAt: now });
        browserRoot.sessionStorage.setItem(
          STORAGE_KEY,
          serializeState(state, now)
        );
      } catch (error) {
        warn('Unable to persist session state.');
      }
    }

    function buildInitialState() {
      if (config.debugMode) {
        return Object.assign(createInitialState(), {
          view: config.debugStartView,
          overlay: config.debugStartOverlay,
          returnView: config.debugStartView === 'popular' ? 'popular' : 'entry'
        });
      }
      return readStoredState() || createInitialState();
    }

    function scanComponents() {
      componentRecords = [];

      COMPONENTS.forEach(function (definition) {
        var node = doc.querySelector(definition.selector);
        if (!node) {
          warn('Missing optional component: ' + definition.key);
          return;
        }
        var wrapper = findWrapper(node);
        componentRecords.push({
          definition: definition,
          node: node,
          wrapper: wrapper
        });
      });
    }

    function applyDebugLabel(record) {
      var wrapper = record.wrapper;
      if (!wrapper) return;

      if (config.showComponentLabels && !record.definition.overlay) {
        wrapper.setAttribute(
          'data-baby-name-component-label',
          record.definition.label
        );
      } else {
        wrapper.removeAttribute('data-baby-name-component-label');
      }
    }

    function setVisibility(record, visible) {
      record.wrapper.hidden = !visible;
      if (record.node !== record.wrapper) record.node.hidden = !visible;
      record.wrapper.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function syncDialogs() {
      var dialogMap = {
        lead_gate: 'baby-name-lead-gate',
        lead_form: 'baby-name-lead-form'
      };

      Object.keys(dialogMap).forEach(function (overlayName) {
        var id = dialogMap[overlayName];
        var overlay = doc.querySelector('[data-yg-bn-dialog="' + id + '"]');
        if (!overlay) return;

        var shouldOpen = state.overlay === overlayName;
        var isOpen = overlay.classList.contains('is-open');
        if (shouldOpen === isOpen) return;

        if (browserRoot && browserRoot.YgBabyNameDialog) {
          browserRoot.YgBabyNameDialog[shouldOpen ? 'open' : 'close'](id);
        } else {
          overlay.classList.toggle('is-open', shouldOpen);
        }
      });
    }

    function render() {
      componentRecords.forEach(function (record) {
        var definition = record.definition;
        applyDebugLabel(record);

        if (definition.overlay) {
          setVisibility(record, true);
          return;
        }

        if (config.enabled === false) {
          setVisibility(record, true);
          return;
        }

        if (definition.sharedSetting) {
          setVisibility(record, config[definition.sharedSetting] !== false);
          return;
        }

        setVisibility(record, definition.views.indexOf(state.view) !== -1);
      });

      if (doc.documentElement) {
        doc.documentElement.setAttribute(
          'data-baby-name-view',
          config.enabled === false ? 'disabled' : state.view
        );
        doc.documentElement.setAttribute(
          'data-baby-name-overlay',
          config.enabled === false ? 'none' : state.overlay || 'none'
        );
      }
      if (config.enabled === false && state.overlay !== null) {
        state = Object.assign({}, state, { overlay: null });
      }
      syncDialogs();
    }

    function focusGeneration() {
      scrollToSelector(doc, GENERATION_SCROLL_TARGET, {
        behavior: scrollBehavior(browserRoot),
        focus: true
      });
    }

    function showCopyFeedback() {
      var status = doc.querySelector('[data-baby-name-copy-status]');
      var labels = readFlowLabels();
      if (status)
        status.textContent =
          (labels && labels.copySuccess) || 'Código de descuento copiado.';
    }

    function getLoginComponent() {
      return doc.querySelector('[data-baby-name-component="login-modal"]');
    }

    function hideLoginModal() {
      var component = getLoginComponent();
      var overlay =
        component &&
        component.querySelector(
          '[data-yg-bn-dialog="' + LOGIN_DIALOG_ID + '"]'
        );
      if (!overlay || !overlay.classList.contains('is-open')) return false;
      if (browserRoot && browserRoot.YgBabyNameDialog) {
        browserRoot.YgBabyNameDialog.close(LOGIN_DIALOG_ID);
      } else {
        overlay.classList.remove('is-open');
      }
      return true;
    }

    function showLoginModal() {
      if (isLoggedIn(browserRoot, doc)) return false;
      var component = getLoginComponent();
      if (!component) {
        warn('Missing login modal component.');
        return false;
      }
      if (browserRoot && browserRoot.YgBabyNameDialog) {
        browserRoot.YgBabyNameDialog.open(LOGIN_DIALOG_ID);
      } else {
        var overlay = component.querySelector(
          '[data-yg-bn-dialog="' + LOGIN_DIALOG_ID + '"]'
        );
        if (overlay) overlay.classList.add('is-open');
      }
      return true;
    }

    function stopLoginMonitor() {
      if (
        !loginMonitorId ||
        !browserRoot ||
        typeof browserRoot.clearInterval !== 'function'
      )
        return;
      browserRoot.clearInterval(loginMonitorId);
      loginMonitorId = null;
    }

    function startLoginMonitor() {
      if (
        loginMonitorId ||
        !browserRoot ||
        typeof browserRoot.setInterval !== 'function'
      )
        return;
      loginMonitorId = browserRoot.setInterval(function () {
        if (!isLoggedIn(browserRoot, doc)) return;
        stopLoginMonitor();
        hideLoginModal();
        if (
          browserRoot.location &&
          typeof browserRoot.location.reload === 'function'
        ) {
          browserRoot.location.reload();
        }
      }, 5000);
    }

    function handleFlowEvent(event) {
      if (event.type === 'baby-names:login-required') {
        showLoginModal();
        return;
      }
      if (config.enabled === false) return;
      if (event.type === 'baby-names:overlay-close') {
        var closingDialogId = getClosingLeadDialogId(event);
        if (closingDialogId) resetLeadDialog(closingDialogId, doc);
      }
      var previousState = state;
      var nextState = transitionState(state, event.type, event.detail);

      if (event.type === 'baby-names:focus-generator') focusGeneration();
      if (event.type === 'baby-names:copy') showCopyFeedback();

      if (nextState === previousState) {
        if (
          event.type !== 'baby-names:focus-generator' &&
          event.type !== 'baby-names:copy'
        ) {
          warn(
            'Ignored invalid transition: ' + event.type + ' from ' + state.view
          );
        }
        return;
      }

      state = nextState;
      writeStoredState();
      render();

      if (event.type === 'baby-names:refine') {
        browserRoot.setTimeout(focusGeneration, 0);
      }
    }

    function dispatchFromTrigger(trigger) {
      var eventName = trigger.getAttribute('data-baby-name-event');
      if (ACTION_EVENTS.indexOf(eventName) === -1) return;

      var detail = {};
      if (trigger.getAttribute('data-baby-name-return-view')) {
        detail.returnView = trigger.getAttribute('data-baby-name-return-view');
      }
      trigger.dispatchEvent(
        new browserRoot.CustomEvent(eventName, {
          bubbles: true,
          detail: detail
        })
      );
    }

    function onClick(event) {
      var loginLink = event.target.closest('[data-baby-name-login-link]');
      if (loginLink) {
        startLoginMonitor();
        hideLoginModal();
        return;
      }
      var trigger = event.target.closest('[data-baby-name-event]');
      if (!trigger) return;
      event.preventDefault();
      dispatchFromTrigger(trigger);
    }

    function onDialogConfirm(event) {
      var dialog = event.target.closest('[data-yg-bn-dialog]');
      if (!dialog) return;
      var eventName = getDialogAction(
        dialog.getAttribute('data-yg-bn-dialog'),
        'confirm'
      );
      if (!eventName) return;
      dialog.dispatchEvent(
        new browserRoot.CustomEvent(eventName, { bubbles: true })
      );
    }

    function onDialogCancel(event) {
      var dialog = event.target.closest('[data-yg-bn-dialog]');
      if (!dialog) return;
      var eventName = getDialogAction(
        dialog.getAttribute('data-yg-bn-dialog'),
        'cancel'
      );
      if (!eventName) return;
      dialog.dispatchEvent(
        new browserRoot.CustomEvent(eventName, { bubbles: true })
      );
    }

    doc.addEventListener('click', onClick);
    doc.addEventListener('baby-name:dialog:confirm', onDialogConfirm);
    doc.addEventListener('baby-name:dialog:cancel', onDialogCancel);
    ACTION_EVENTS.forEach(function (eventName) {
      doc.addEventListener(eventName, handleFlowEvent);
    });

    state = buildInitialState();
    scanComponents();
    render();
    writeStoredState();

    browserRoot.YGLoginModal = {
      show: showLoginModal,
      hide: hideLoginModal,
      getState: function () {
        var component = getLoginComponent();
        var overlay =
          component &&
          component.querySelector(
            '[data-yg-bn-dialog="' + LOGIN_DIALOG_ID + '"]'
          );
        return {
          isVisible: Boolean(overlay && overlay.classList.contains('is-open'))
        };
      }
    };

    return {
      refresh: function (resetFromDebugConfig) {
        flowElement = doc.querySelector('baby-name-flow') || flowElement;
        config = readConfig(flowElement);
        if (resetFromDebugConfig && config.debugMode) {
          state = buildInitialState();
          writeStoredState();
        }
        scanComponents();
        render();
      },
      getState: function () {
        return Object.assign({}, state);
      }
    };
  }

  function createUrlBrowserController(doc, flowElement) {
    var config = readConfig(flowElement);
    var route = { view: 'entry' };
    var overlay = null;
    var componentRecords = [];
    var pendingResultsRoute = null;
    var loginMonitorId = null;

    function warn(message) {
      if (config.debugMode && browserRoot && browserRoot.console) {
        browserRoot.console.warn('[BabyNameFlow] ' + message);
      }
    }

    function readSuccessGrant() {
      if (!browserRoot || !browserRoot.sessionStorage) return null;
      try {
        return browserRoot.sessionStorage.getItem(SUCCESS_STORAGE_KEY);
      } catch (error) {
        return null;
      }
    }

    function grantSuccess() {
      if (!browserRoot || !browserRoot.sessionStorage) return null;
      var grant = createSuccessGrant();
      try {
        browserRoot.sessionStorage.setItem(SUCCESS_STORAGE_KEY, grant);
      } catch (error) {
        warn('Unable to persist the success grant.');
      }
      return grant;
    }

    function clearLegacyState() {
      if (!browserRoot || !browserRoot.sessionStorage) return;
      try {
        browserRoot.sessionStorage.removeItem(STORAGE_KEY);
      } catch (error) {
        warn('Unable to clear legacy flow state.');
      }
    }

    function scanComponents() {
      componentRecords = [];
      COMPONENTS.forEach(function (definition) {
        var node = doc.querySelector(definition.selector);
        if (!node) {
          warn('Missing optional component: ' + definition.key);
          return;
        }
        componentRecords.push({
          definition: definition,
          node: node,
          wrapper: findWrapper(node)
        });
      });
    }

    function setVisibility(record, visible) {
      if (!record.wrapper) return;
      record.wrapper.hidden = !visible;
      if (record.node !== record.wrapper) record.node.hidden = !visible;
      record.wrapper.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (config.showComponentLabels && !record.definition.overlay) {
        record.wrapper.setAttribute(
          'data-baby-name-component-label',
          record.definition.label
        );
      } else {
        record.wrapper.removeAttribute('data-baby-name-component-label');
      }
    }

    function syncDialogs() {
      var dialogMap = {
        lead_gate: 'baby-name-lead-gate',
        lead_form: 'baby-name-lead-form'
      };
      Object.keys(dialogMap).forEach(function (overlayName) {
        var id = dialogMap[overlayName];
        var dialog = doc.querySelector('[data-yg-bn-dialog="' + id + '"]');
        if (!dialog) return;
        var shouldOpen = overlay === overlayName;
        var isOpen = dialog.classList.contains('is-open');
        if (shouldOpen === isOpen) return;
        if (browserRoot.YgBabyNameDialog)
          browserRoot.YgBabyNameDialog[shouldOpen ? 'open' : 'close'](id);
        else dialog.classList.toggle('is-open', shouldOpen);
      });
    }

    function render() {
      componentRecords.forEach(function (record) {
        var definition = record.definition;
        if (definition.overlay) return setVisibility(record, true);
        if (config.enabled === false) return setVisibility(record, true);
        if (definition.sharedSetting)
          return setVisibility(
            record,
            config[definition.sharedSetting] !== false
          );
        setVisibility(record, definition.views.indexOf(route.view) !== -1);
      });
      if (doc.documentElement) {
        doc.documentElement.setAttribute(
          'data-baby-name-view',
          config.enabled === false ? 'disabled' : route.view
        );
        doc.documentElement.setAttribute(
          'data-baby-name-overlay',
          overlay || 'none'
        );
      }
      syncDialogs();
    }

    function emitRouteChange(navigationType) {
      var historyState = browserRoot.history && browserRoot.history.state;
      doc.dispatchEvent(
        new browserRoot.CustomEvent('baby-names:route-change', {
          detail: {
            route: Object.assign({}, route),
            navigationType: navigationType || 'replace',
            seed: historyState && historyState.seed ? historyState.seed : null
          }
        })
      );
    }

    function scrollToRoute(nextRoute, options) {
      options = options || {};
      if (options.scroll === false) return false;
      var anchor = options.anchor;
      if (!anchor && nextRoute && nextRoute.view === 'entry') {
        anchor = consumeReturnAnchor();
      }
      var selector =
        options.scrollTarget ||
        getViewScrollSelector(nextRoute && nextRoute.view, anchor);
      if (!selector) return false;
      return scrollToSelector(doc, selector, {
        behavior: options.behavior || scrollBehavior(browserRoot),
        focus: options.focus
      });
    }

    function navigateTo(nextRoute, options) {
      options = options || {};
      route = navigate(browserRoot, nextRoute, {
        replace: options.replace === true,
        state: options.state,
        successGrant: readSuccessGrant(),
        apiLocale: config.apiLocale
      });
      overlay = null;
      // Contract: show target → scroll → broadcast route-change (loaders fetch after).
      render();
      scrollToRoute(route, options);
      emitRouteChange(options.replace ? 'replace' : 'push');
      return route;
    }

    function syncFromLocation(navigationType) {
      // Preserve the original entry reason so URL canonicalization cannot force a first-paint scroll.
      var isInitial = !navigationType || navigationType === 'initial';
      var resolvedType = navigationType || 'initial';
      route = parseRoute(browserRoot.location.search, {
        successGrant: readSuccessGrant(),
        apiLocale: config.apiLocale
      });
      var canonicalSearch = serializeRoute(route, browserRoot.location.search, {
        apiLocale: config.apiLocale
      });
      if (canonicalSearch !== browserRoot.location.search) {
        route = navigate(browserRoot, route, {
          replace: true,
          state: browserRoot.history && browserRoot.history.state,
          successGrant: readSuccessGrant(),
          apiLocale: config.apiLocale
        });
        if (!isInitial) resolvedType = 'replace';
      } else if (
        !browserRoot.history.state ||
        !browserRoot.history.state.babyName
      ) {
        navigate(browserRoot, route, {
          replace: true,
          state: {},
          successGrant: readSuccessGrant(),
          apiLocale: config.apiLocale
        });
      }
      overlay = null;
      render();
      // First direct load must not force-scroll; later popstate/refresh still scrolls.
      if (!isInitial) {
        scrollToRoute(route, { scroll: true });
      }
      emitRouteChange(isInitial ? 'initial' : resolvedType);
    }

    function focusGeneration() {
      scrollToSelector(doc, GENERATION_SCROLL_TARGET, {
        behavior: scrollBehavior(browserRoot),
        focus: true
      });
    }

    function getLoginComponent() {
      return doc.querySelector('[data-baby-name-component="login-modal"]');
    }

    function hideLoginModal() {
      var component = getLoginComponent();
      var dialog =
        component &&
        component.querySelector(
          '[data-yg-bn-dialog="' + LOGIN_DIALOG_ID + '"]'
        );
      if (!dialog || !dialog.classList.contains('is-open')) return false;
      if (browserRoot.YgBabyNameDialog)
        browserRoot.YgBabyNameDialog.close(LOGIN_DIALOG_ID);
      else dialog.classList.remove('is-open');
      return true;
    }

    function showLoginModal() {
      if (isLoggedIn(browserRoot, doc)) return false;
      var component = getLoginComponent();
      if (!component) return false;
      if (browserRoot.YgBabyNameDialog)
        browserRoot.YgBabyNameDialog.open(LOGIN_DIALOG_ID);
      else {
        var dialog = component.querySelector(
          '[data-yg-bn-dialog="' + LOGIN_DIALOG_ID + '"]'
        );
        if (dialog) dialog.classList.add('is-open');
      }
      return true;
    }

    function stopLoginMonitor() {
      if (!loginMonitorId || typeof browserRoot.clearInterval !== 'function')
        return;
      browserRoot.clearInterval(loginMonitorId);
      loginMonitorId = null;
    }

    function startLoginMonitor() {
      if (loginMonitorId || typeof browserRoot.setInterval !== 'function')
        return;
      loginMonitorId = browserRoot.setInterval(function () {
        if (!isLoggedIn(browserRoot, doc)) return;
        stopLoginMonitor();
        hideLoginModal();
        if (
          browserRoot.location &&
          typeof browserRoot.location.reload === 'function'
        )
          browserRoot.location.reload();
      }, 5000);
    }

    function readFlowLabels() {
      var defaults = {
        email: 'Introduce una dirección de correo válida.',
        dueDate: 'Introduce la fecha prevista / el cumpleaños del bebé.',
        optIn: 'Marca la casilla para continuar.',
        fieldFallback: 'Revisa este campo.',
        copySuccess: 'Código de descuento copiado.'
      };
      var labelsNode = doc.querySelector('script[data-baby-name-flow-labels]');
      if (!labelsNode) return defaults;
      try {
        return Object.assign(
          defaults,
          JSON.parse(labelsNode.textContent || '{}') || {}
        );
      } catch (error) {
        return defaults;
      }
    }

    var LEAD_FIELD_ERRORS = readFlowLabels();

    function clearFieldErrors(dialog) {
      if (!dialog) return;
      dialog
        .querySelectorAll('[aria-invalid="true"]')
        .forEach(function (field) {
          field.removeAttribute('aria-invalid');
        });
      dialog
        .querySelectorAll('[data-baby-name-field-error]')
        .forEach(function (node) {
          node.hidden = true;
          node.textContent = '';
        });
    }

    function markInvalid(dialog, fieldName, field, shouldFocus) {
      if (!field) return;
      field.setAttribute('aria-invalid', 'true');
      var message =
        LEAD_FIELD_ERRORS[fieldName] ||
        LEAD_FIELD_ERRORS.fieldFallback ||
        'Revisa este campo.';
      var errorNode =
        (dialog &&
          dialog.querySelector(
            '[data-baby-name-field-error="' + fieldName + '"]'
          )) ||
        null;
      if (errorNode) {
        errorNode.textContent = message;
        errorNode.hidden = false;
      } else {
        field.setAttribute('title', message);
      }
      if (shouldFocus !== false && typeof field.focus === 'function')
        field.focus();
    }

    function collectLeadPayload(dialog) {
      var email = dialog.querySelector('input[type="email"]');
      var dueDate = dialog.querySelector('input[type="date"]');
      var optIn = dialog.querySelector('input[type="checkbox"]');
      return {
        fields: { email: email, dueDate: dueDate, optIn: optIn },
        value: {
          email: email ? email.value : '',
          dueDate: dueDate ? dueDate.value : '',
          optIn: Boolean(optIn && optIn.checked)
        }
      };
    }

    function resetLeadFormDialog() {
      resetLeadDialog('baby-name-lead-form', doc);
    }

    function handleFlowEvent(event) {
      if (event.type === 'baby-names:login-required') return showLoginModal();
      if (config.enabled === false) return;
      var detail = event.detail || {};

      if (event.type === 'baby-names:focus-generator') return focusGeneration();
      if (event.type === 'baby-names:generate') {
        pendingResultsRoute = Object.assign(
          { view: 'results' },
          detail.payload && detail.payload.filter
        );
        overlay = 'lead_gate';
        return render();
      }
      if (event.type === 'baby-names:gate-skip') {
        if (overlay !== 'lead_gate') return;
        return navigateTo(pendingResultsRoute || { view: 'results' });
      }
      if (event.type === 'baby-names:gate-submit') {
        if (overlay !== 'lead_gate') return;
        trackBabyNameGeneratorSubscribe(
          Object.assign({}, detail, {
            firstname: detail.firstname || config.customerFirstName
          }),
          'baby_name_lead_gate'
        );
        return navigateTo(pendingResultsRoute || { view: 'results' });
      }
      if (event.type === 'baby-names:search') {
        rememberReturnAnchor('search');
        return navigateTo(
          { view: 'detail', name: detail.name },
          {
            state: {
              sourceView: 'entry',
              scrollAnchor: 'search'
            }
          }
        );
      }
      if (event.type === 'baby-names:view-popular') {
        return navigateTo({
          view: 'popular',
          country: defaultPopularCountry({ apiLocale: config.apiLocale }),
          gender: 'girl'
        });
      }
      if (event.type === 'baby-names:select') {
        var selected = detail.name || {};
        var name =
          typeof selected === 'string'
            ? selected
            : selected.first_name || selected.name;
        return navigateTo(
          { view: 'detail', name: name },
          {
            state: {
              sourceView: route.view,
              seed: typeof selected === 'object' ? selected : null
            }
          }
        );
      }
      if (event.type === 'baby-names:back' && route.view === 'detail') {
        var state = browserRoot.history && browserRoot.history.state;
        if (isSearchOriginDetail(state)) {
          rememberReturnAnchor('search');
          return navigateTo({ view: 'entry' }, { replace: true });
        }
        if (hasDetailReturnHistory(state)) {
          return browserRoot.history.back();
        }
        return navigateTo({ view: 'entry' });
      }
      if (event.type === 'baby-names:refine') {
        return navigateTo({ view: 'entry' }, { anchor: 'generation' });
      }
      if (
        event.type === 'baby-names:results-change' &&
        route.view === 'results'
      ) {
        return navigateTo(
          Object.assign({}, route, detail, { view: 'results' })
        );
      }
      if (
        event.type === 'baby-names:popular-change' &&
        route.view === 'popular'
      ) {
        return navigateTo(
          Object.assign({}, route, detail, { view: 'popular' })
        );
      }
      if (
        event.type === 'baby-names:lead-open' &&
        (route.view === 'results' || route.view === 'detail')
      ) {
        resetLeadFormDialog();
        overlay = 'lead_form';
        return render();
      }
      if (event.type === 'baby-names:lead-submit' && overlay === 'lead_form') {
        var validation = validateLeadPayload(detail, { requireOptIn: true });
        if (!validation.valid) return;
        trackBabyNameGeneratorSubscribe(
          Object.assign({}, validation.value, {
            firstname:
              validation.value.firstname ||
              detail.firstname ||
              config.customerFirstName
          }),
          'baby_name_lead_form'
        );
        grantSuccess();
        return navigateTo({ view: 'success' });
      }
      if (event.type === 'baby-names:overlay-close') {
        var closingDialogId = getClosingLeadDialogId(event);
        if (closingDialogId) resetLeadDialog(closingDialogId, doc);
        overlay = null;
        return render();
      }
      if (event.type === 'baby-names:copy' && route.view === 'success') {
        var status = doc.querySelector('[data-baby-name-copy-status]');
        if (status) {
          status.textContent =
            LEAD_FIELD_ERRORS.copySuccess || 'Código de descuento copiado.';
        }
      }
    }

    function dispatchFromTrigger(trigger) {
      var eventName = trigger.getAttribute('data-baby-name-event');
      if (ACTION_EVENTS.indexOf(eventName) === -1) return;
      var detail = {};
      if (trigger.getAttribute('data-baby-name-return-view')) {
        detail.returnView = trigger.getAttribute('data-baby-name-return-view');
      }
      trigger.dispatchEvent(
        new browserRoot.CustomEvent(eventName, {
          bubbles: true,
          detail: detail
        })
      );
    }

    function onClick(event) {
      var loginLink = event.target.closest('[data-baby-name-login-link]');
      if (loginLink) {
        startLoginMonitor();
        hideLoginModal();
        return;
      }
      var trigger = event.target.closest('[data-baby-name-event]');
      if (!trigger) return;
      event.preventDefault();
      dispatchFromTrigger(trigger);
    }

    function onDialogConfirm(event) {
      var dialog = event.target.closest('[data-yg-bn-dialog]');
      if (!dialog) return;
      var dialogId = dialog.getAttribute('data-yg-bn-dialog');
      if (
        dialogId === 'baby-name-lead-form' ||
        dialogId === 'baby-name-lead-gate'
      ) {
        var lead = collectLeadPayload(dialog);
        var validation = validateLeadPayload(lead.value, {
          requireOptIn: dialogId === 'baby-name-lead-form'
        });
        clearFieldErrors(dialog);
        if (!validation.valid) {
          // Keep the dialog open so the user can fix the invalid fields.
          if (typeof event.preventDefault === 'function')
            event.preventDefault();
          var invalidFields = validation.fields || [validation.field];
          invalidFields.forEach(function (fieldName, index) {
            markInvalid(dialog, fieldName, lead.fields[fieldName], index === 0);
          });
          return;
        }
        var eventName =
          dialogId === 'baby-name-lead-form'
            ? 'baby-names:lead-submit'
            : 'baby-names:gate-submit';
        dialog.dispatchEvent(
          new browserRoot.CustomEvent(eventName, {
            bubbles: true,
            detail: validation.value
          })
        );
        // Flow owns dialog open/close via overlay + syncDialogs; prevent dialog auto-close.
        if (typeof event.preventDefault === 'function') event.preventDefault();
        return;
      }
      var fallbackEvent = getDialogAction(dialogId, 'confirm');
      if (fallbackEvent)
        dialog.dispatchEvent(
          new browserRoot.CustomEvent(fallbackEvent, { bubbles: true })
        );
    }

    function onDialogCancel(event) {
      var dialog = event.target.closest('[data-yg-bn-dialog]');
      if (!dialog) return;
      var eventName = getDialogAction(
        dialog.getAttribute('data-yg-bn-dialog'),
        'cancel'
      );
      if (eventName)
        dialog.dispatchEvent(
          new browserRoot.CustomEvent(eventName, { bubbles: true })
        );
    }

    var flowAbort = browserRoot.AbortController
      ? new browserRoot.AbortController()
      : null;
    var flowSignal = flowAbort ? flowAbort.signal : undefined;
    var flowListenerOpts = flowSignal ? { signal: flowSignal } : false;

    function onPopState() {
      syncFromLocation('popstate');
    }

    doc.addEventListener('click', onClick, flowListenerOpts);
    doc.addEventListener(
      'baby-name:dialog:confirm',
      onDialogConfirm,
      flowListenerOpts
    );
    doc.addEventListener(
      'baby-name:dialog:cancel',
      onDialogCancel,
      flowListenerOpts
    );
    ACTION_EVENTS.forEach(function (eventName) {
      doc.addEventListener(eventName, handleFlowEvent, flowListenerOpts);
    });
    browserRoot.addEventListener('popstate', onPopState, flowListenerOpts);

    if (flowElement) {
      doc.addEventListener(
        'shopify:section:unload',
        function onFlowUnload(event) {
          if (!event.target || !flowElement) return;
          if (
            event.target !== flowElement &&
            !event.target.contains(flowElement)
          )
            return;
          if (flowAbort) flowAbort.abort();
          doc.removeEventListener('shopify:section:unload', onFlowUnload);
        }
      );
    }

    clearLegacyState();
    scanComponents();
    syncFromLocation('initial');

    browserRoot.YGLoginModal = {
      show: showLoginModal,
      hide: hideLoginModal,
      getState: function () {
        var component = getLoginComponent();
        var dialog =
          component &&
          component.querySelector(
            '[data-yg-bn-dialog="' + LOGIN_DIALOG_ID + '"]'
          );
        return {
          isVisible: Boolean(dialog && dialog.classList.contains('is-open'))
        };
      }
    };

    return {
      /**
       * @param {boolean} [resyncRoute] When true (Flow section reload), re-read URL and broadcast.
       * When false/omitted for Theme Editor sibling section reloads, only re-scan DOM + render.
       */
      refresh: function (resyncRoute) {
        flowElement = doc.querySelector('baby-name-flow') || flowElement;
        config = readConfig(flowElement);
        scanComponents();
        render();
        if (resyncRoute) syncFromLocation('refresh');
      },
      getState: function () {
        return { route: Object.assign({}, route), overlay: overlay };
      }
    };
  }

  function boot(doc) {
    if (!doc || !browserRoot) return null;

    var initialize = function () {
      var flowElement = doc.querySelector('baby-name-flow');
      if (!flowElement) return null;

      if (!activeController) {
        activeController = createUrlBrowserController(doc, flowElement);
        doc.addEventListener('shopify:section:load', function (event) {
          var loadedSection = event.target;
          var loadedFlow =
            loadedSection &&
            ((loadedSection.matches &&
              loadedSection.matches('baby-name-flow')) ||
              (loadedSection.querySelector &&
                loadedSection.querySelector('baby-name-flow')));
          // Only re-broadcast/scroll when the Flow section itself reloads.
          if (activeController) activeController.refresh(Boolean(loadedFlow));
        });
      } else {
        activeController.refresh(false);
      }
      return activeController;
    };

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', initialize, { once: true });
      return null;
    }
    return initialize();
  }

  return {
    VERSION: VERSION,
    VIEWS: VIEWS.slice(),
    OVERLAYS: OVERLAYS.slice(),
    ACTION_EVENTS: ACTION_EVENTS.slice(),
    STORAGE_KEY: STORAGE_KEY,
    SUCCESS_STORAGE_KEY: SUCCESS_STORAGE_KEY,
    ROUTE_PARAM: ROUTE_PARAM,
    BABY_PARAM_KEYS: BABY_PARAM_KEYS.slice(),
    VIEW_SCROLL_TARGETS: Object.assign({}, VIEW_SCROLL_TARGETS),
    GENERATION_SCROLL_TARGET: GENERATION_SCROLL_TARGET,
    SEARCH_SCROLL_TARGET: SEARCH_SCROLL_TARGET,
    rememberReturnAnchor: rememberReturnAnchor,
    consumeReturnAnchor: consumeReturnAnchor,
    isSearchOriginDetail: isSearchOriginDetail,
    UI: UI,
    prefersReducedMotion: prefersReducedMotion,
    scrollBehavior: scrollBehavior,
    getViewScrollSelector: getViewScrollSelector,
    normalizeRoute: normalizeRoute,
    parseRoute: parseRoute,
    serializeRoute: serializeRoute,
    navigate: navigate,
    hasDetailReturnHistory: hasDetailReturnHistory,
    validateLeadPayload: validateLeadPayload,
    trackBabyNameGeneratorSubscribe: trackBabyNameGeneratorSubscribe,
    createSuccessGrant: createSuccessGrant,
    hasSuccessGrant: hasSuccessGrant,
    getLoginCookieName: getLoginCookieName,
    hasLoginCookie: hasLoginCookie,
    isLoggedIn: isLoggedIn,
    createInitialState: createInitialState,
    transitionState: transitionState,
    getDialogAction: getDialogAction,
    serializeState: serializeState,
    restoreState: restoreState,
    boot: boot
  };
});
